/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddAttachmentsResponseBaseResponse as ModelsV3LoanManagementAddAttachmentsResponseBaseResponse } from '../../models/Models/v3/LoanManagement/add-attachments-response-base-response';

export interface V3LoanManagementAttachmentsUploadPost$Plain$Params {
      body?: {
'file'?: Blob;
'accountId'?: string;
'externalId'?: string;
'description'?: string;
}
}

export function v3LoanManagementAttachmentsUploadPost$Plain(http: HttpClient, rootUrl: string, params?: V3LoanManagementAttachmentsUploadPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementAttachmentsUploadPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementAddAttachmentsResponseBaseResponse>;
    })
  );
}

v3LoanManagementAttachmentsUploadPost$Plain.PATH = '/v3/loan-management/attachments/upload';
